import {
    ActionContext,
    ActionTree,
    GetterTree,
    createStore,
    CommitOptions,
    DispatchOptions,
    MutationTree,
    Store as VuexStore,
} from 'vuex'


import fetch from '../services/fetch'
import {
    User,
    Index,
    Order,
    OrderUsers,
    Product,
    Drift,
    Yield,
    ProductLine,
    IndicesCategories,
    Repo,
    UserDataType,
    LoginPayload, PasswordRequestToken, PasswordChangeRequest,
    ChartData, IndexChartTick, ProductD, ClientOrder, NotificationSetting
} from '../types'
import AuthService from '../services/auth.service';
//import OrdersList from "/@src/pages/orders/OrdersList.vue";


export type State = {
    token_stored: any;
    refresh_stored: any;
    loggedIn: boolean;
    user?: User;
    group_id?: number;
    emailForToken: string;
    users: User[];
    hasLoadedUser: boolean;
    pushed_to_repo: boolean;
    indexDeleted: boolean,
    indices: Index[];
    products: Product[];
    index?: Index;
    orders?: Order[];
    clientorders?: ClientOrder[],
    orderusers?: OrderUsers[];
    repos: Repo[];
    isAuthenticated: boolean;
    userData?: UserDataType;
    drift_data?: Drift;
    products_repo: Product[];
    credentials: LoginPayload;
    accessToken: string;
    chartData: ChartData;
    strat_name: string;
    tabvalue: string;
}

const state: State = {
    user: {
        password: '',
        first_name: '',
        last_name: '',
        email: '',
        initials: '',
        id: 0,
        is_staff: false,
        token: ''
    },
    group_id: 999999999999,
    emailForToken: '',
    accessToken: '',
    refresh_stored: undefined,
    token_stored: undefined,
    loggedIn: false,
    users: [],
    hasLoadedUser: false,
    pushed_to_repo: false,
    indexDeleted: false,
    indices: [],
    products: [],
    index: undefined,
    repos: [],
    isAuthenticated: false,
    userData: undefined,
    drift_data: undefined,
    products_repo: [],

    credentials: {
        email: '',
        password: ''
    },
    chartData: {
        strat_name: '',
        ratios_five_min: [],
        ratios_calculated_price: [],
    },
    strat_name: '',
    tabvalue: 'assigned'
}

// Mutations enums
export enum MutationTypes {
    SET_CURRENT_USER = 'SET_CURRENT_USER',
    SET_USERS = 'SET_USERS',
    SET_HAS_LOADED_USER = 'SET_HAS_LOADED_USER',
    SET_INDICES = 'SET_INDICES',
    INDEX_DELETED = 'INDEX_DELETED',
    SET_PRODUCTS = 'SET_PRODUCTS',
    SET_PRODUCTS_REPO = 'SET_PRODUCTS_REPO',
    SET_DRIFT = 'SET_DRIFT',
    SET_INDEX = 'SET_INDEX',
    SET_ORDER = 'SET_ORDER',
    SET_CLIENT_ORDER = 'SET_CLIENT_ORDER',
    SET_REPOS = 'SET_REPOS',
    SET_USER_DATA = 'SET_USER_DATA',
    SET_PUSH_TO_PRIME = 'SET_PUSH_TO_PRIME',
    CLEAR_USER_DATA = 'CLEAR_USER_DATA',
    loginSuccess = 'loginSuccess',
    loginFailure = 'loginFailure',
    logout = 'logout',
    refreshToken = 'refreshToken',
    CHART_DATA = 'CHART_DATA',
    SET_ORDER_USERS = 'SET_ORDER_USERS',
}


export type Mutations<S = State> = {
    [MutationTypes.SET_CURRENT_USER](state: S, user: User): void;
    [MutationTypes.SET_HAS_LOADED_USER](state: S, hasLoaded: boolean): void;
    [MutationTypes.SET_INDICES](state: S, indices: Index[]): void;
    [MutationTypes.INDEX_DELETED](state: S, indexDeleted: boolean): void;
    [MutationTypes.SET_PRODUCTS](state: S, products: Product[]): void;
    [MutationTypes.SET_PRODUCTS_REPO](state: S, products_repo: Product[]): void;
    [MutationTypes.SET_DRIFT](state: S, drift_data: Drift): void;
    [MutationTypes.SET_INDEX](state: S, index?: any): void;
    [MutationTypes.SET_ORDER](state: S, Order?: any): void;
    [MutationTypes.SET_CLIENT_ORDER](state: S, ClientOrder?: any): void;
    [MutationTypes.SET_ORDER_USERS](state: S, OrderUsers?: any): void;
    [MutationTypes.SET_USERS](state: S, users: User[]): void;
    [MutationTypes.SET_REPOS](state: S, repos: Repo[]): void;
    [MutationTypes.SET_PUSH_TO_PRIME](state: S, pushed_to_repo: boolean): void;
    [MutationTypes.SET_USER_DATA](state: S, userdata: any): void;
    [MutationTypes.CLEAR_USER_DATA](state: S, userData?: UserDataType): void;
    [MutationTypes.loginSuccess](state: S, auth_tokens: any): void;
    [MutationTypes.loginFailure](state: S, error: Error): void;
    [MutationTypes.logout](state: S, token_stored: any): void;
    [MutationTypes.CHART_DATA](state: S, chartData: ChartData): void;
}

// Define mutations
const mutations: MutationTree<State> & Mutations = {
    [MutationTypes.SET_CURRENT_USER](state: State, user: User) {
        state.user = user
    },

    [MutationTypes.SET_USERS](state: State, users: User[]) {
        state.users = users
    },
    [MutationTypes.SET_HAS_LOADED_USER](state: State, hasLoaded: boolean) {
        state.hasLoadedUser = hasLoaded
    },
    [MutationTypes.SET_INDICES](state: State, indices: Index[]) {
        state.indices = indices
    },
    [MutationTypes.INDEX_DELETED](state: State, indexDeleted: boolean) {
        state.indexDeleted = indexDeleted
    },
    [MutationTypes.SET_PRODUCTS](state: State, products: Product[]) {
        state.products = products
    },
    [MutationTypes.SET_PRODUCTS_REPO](state: State, products_repo: Product[]) {
        state.products_repo = products_repo
    },
    [MutationTypes.SET_DRIFT](state: State, drift_data: Drift) {
        state.drift_data = drift_data;
    },
    [MutationTypes.SET_INDEX](state: State, index?: Index) {
        state.index = index
    },
    [MutationTypes.SET_ORDER](state: State, orders: Order[]) {
        state.orders = orders
    },
    [MutationTypes.SET_CLIENT_ORDER](state: State, clientorders: ClientOrder[]) {
        state.clientorders = clientorders
    },
    [MutationTypes.SET_ORDER_USERS](state: State, orderusers: OrderUsers[]) {
        state.orderusers = orderusers
    },
    [MutationTypes.SET_REPOS](state: State, repos: Repo[]) {
        state.repos = repos
    },
    [MutationTypes.SET_PUSH_TO_PRIME](state: State, pushed_to_repo: boolean) {
        state.pushed_to_repo = pushed_to_repo
    },
    [MutationTypes.SET_USER_DATA](state: State, userData?: UserDataType) {
        state.userData = userData
    },
    [MutationTypes.CLEAR_USER_DATA](state: State, userData?: UserDataType) {
        state.userData = userData
    },
    [MutationTypes.loginSuccess](state: State, auth_tokens: any) {
        state.loggedIn = true;
        state.token_stored = auth_tokens.access;
        state.refresh_stored = auth_tokens.refresh;
    },
    [MutationTypes.loginFailure](state: State) {
        state.loggedIn = false;
        state.token_stored = null;
        state.refresh_stored = null;
    },
    [MutationTypes.logout](state: State) {
        state.loggedIn = false;
        state.token_stored = null;
        state.refresh_stored = null;
    },
    [MutationTypes.CHART_DATA](state: State, chartData: ChartData) {
        state.chartData = chartData;
    },
}

// getters types
export type Getters = {
    isStaff(state: State): boolean;

}

// getters
export const getters: GetterTree<State, State> & Getters = {
    isStaff: (state) => {
        if (state.user === undefined) {
            return false
        }
        return state.user.is_staff
    },
    currentUser: (store) => {
        if (store.user === undefined) {
            return false
        }

        return store.user


    },
    resetUser: (store) => {
        if (store.user) {
            store.user = undefined
            return store.user
        }

        return store.user


    },
}

// Actions context
type AugmentedActionContext = {
    commit<K extends keyof Mutations>(
        key: K,
        payload: Parameters<Mutations[K]>[1],
    ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, State>, 'commit'>

// Action enums
export enum ActionTypes {
    FETCH_CURRENT_USER = 'FETCH_CURRENT_USER',
    SEND_TICK_DATA = 'SEND_TICK_DATA',
    LOAD_TICK_DATA = 'LOAD_TICK_DATA',
    SET_CHART_ENABLED = 'SET_CHART_ENABLED',
    FETCH_INDICES = 'FETCH_INDICES',
    FETCH_INDEX = 'FETCH_INDEX',
    INDEX_DELETE = 'INDEX_DELETE',
    FETCH_PRODUCTS = 'FETCH_PRODUCTS',
    FETCH_PRODUCTS_D = 'FETCH_PRODUCTS_D',
    CREATE_INDEX = 'CREATE_INDEX',
    SUBMIT_CALC_WEIGHTS = 'SUBMIT_CALC_WEIGHTS',
    SUBMIT_HOUSE_WEIGHTS = 'SUBMIT_HOUSE_WEIGHTS',
    POST_DRIFT = 'POST_DRIFT',
    POST_DRIFT_ALL = 'POST_DRIFT_ALL',
    SUBMIT_YIELD_CALC = 'SUBMIT_YIELD_CALC',
    FETCH_RISK_LIST = 'FETCH_RISK_LIST',
    UPDATE_INDEX = 'UPDATE_INDEX',
    RESET_INDEX = 'RESET_INDEX',
    SET_INDEX = 'SET_INDEX',
    FETCH_USERS = 'FETCH_USERS',
    FETCH_USER_INDICES = 'FETCH_USER_INDICES',
    FETCH_ORDERS = 'FETCH_ORDERS',
    FETCH_CLIENT_ORDERS = 'FETCH_CLIENT_ORDERS',
    FETCH_ORDER_USERS = 'FETCH_ORDER_USERS',
    SUBMIT_GENERATE_NAME = 'SUBMIT_GENERATE_NAME',
    FETCH_COPY_INDEX = 'FETCH_COPY_INDEX',
    FETCH_REPOS = 'FETCH_REPOS',
    CREATE_REPOS = 'CREATE_REPOS',
    PUSH_TO_PRIME = 'PUSH_TO_PRIME',
    ADD_USER_DATA = 'ADD_USER_DATA',
    REMOVE_USER_DATA = 'REMOVE_USER_DATA',
    PASSWORD_TOKEN_REQUEST = 'PASSWORD_TOKEN_REQUEST',
    CHANGE_PASSWORD = 'CHANGE_PASSWORD',
    SET_CHART_DATA = 'SET_CHART_DATA',
    FETCH_PRODUCTS_REPO = 'FETCH_PRODUCTS_REPO',
    FETCH_USERS_WITH_STRATS = 'FETCH_USERS_WITH_STRATS',
    FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS',
}

// Actions contracts
export interface Actions {

    [ActionTypes.FETCH_NOTIFICATIONS](
        {commit}: AugmentedActionContext,
    ): Promise<any>;

    [ActionTypes.PASSWORD_TOKEN_REQUEST](
        {commit}: AugmentedActionContext,
        payload: PasswordRequestToken
    ): Promise<any>;

    [ActionTypes.CHANGE_PASSWORD](
        {commit}: AugmentedActionContext,
        payload: PasswordChangeRequest
    ): Promise<any>;

    [ActionTypes.FETCH_CURRENT_USER](
        {commit}: AugmentedActionContext,
    ): Promise<any>;

    [ActionTypes.FETCH_USERS](
        {commit}: AugmentedActionContext,
        sorted_users: any
    ): Promise<User[]>;

    [ActionTypes.FETCH_INDICES](
        {commit}: AugmentedActionContext,
        category: IndicesCategories
    ): Promise<Index[]>;

    [ActionTypes.FETCH_USER_INDICES](
        {commit}: AugmentedActionContext,
        userID: number
    ): Promise<Index[]>;

    [ActionTypes.FETCH_ORDERS](
        {commit}: AugmentedActionContext,
    ): Promise<Order>;

    [ActionTypes.FETCH_ORDER_USERS](
        {commit}: AugmentedActionContext,
    ): Promise<any>;

    [ActionTypes.FETCH_INDEX](
        {commit}: AugmentedActionContext,
        id: number
    ): Promise<Index>;

    [ActionTypes.INDEX_DELETE](
        {commit}: AugmentedActionContext,
        payload: number
    ): Promise<boolean>;

    [ActionTypes.FETCH_COPY_INDEX](
        {commit}: AugmentedActionContext,
        id: number
    ): Promise<any>;

    [ActionTypes.FETCH_PRODUCTS](
        {commit}: AugmentedActionContext,
    ): Promise<Product[]>;

    [ActionTypes.FETCH_PRODUCTS_D](
        {commit}: AugmentedActionContext,
    ): Promise<ProductD[]>;

    [ActionTypes.CREATE_INDEX](
        {commit}: AugmentedActionContext,
        payload: Index
    ): Promise<Index>;

    [ActionTypes.SUBMIT_CALC_WEIGHTS](
        {commit}: AugmentedActionContext,
        payload: Index
    ): Promise<Index>;

    [ActionTypes.SUBMIT_HOUSE_WEIGHTS](
        {commit}: AugmentedActionContext,
        payload: Index
    ): Promise<Index>;

    [ActionTypes.SUBMIT_GENERATE_NAME](
        {commit}: AugmentedActionContext,
        payload: Index
    ): Promise<Index>;

    [ActionTypes.POST_DRIFT](
        {commit}: AugmentedActionContext,
        payload: Drift
    ): Promise<Drift>;

    [ActionTypes.SUBMIT_YIELD_CALC](
        {commit}: AugmentedActionContext,
        payload: Yield[]
    ): Promise<number>;

    [ActionTypes.FETCH_RISK_LIST](
        {commit}: AugmentedActionContext
    ): Promise<any>;

    [ActionTypes.UPDATE_INDEX](
        {commit}: AugmentedActionContext,
        index: Index
    ): Promise<void>;

    [ActionTypes.SET_INDEX](
        {commit}: AugmentedActionContext,
        index: Index
    ): Promise<any>;

    [ActionTypes.RESET_INDEX](
        {commit}: AugmentedActionContext,
    ): Promise<boolean>;

    [ActionTypes.PUSH_TO_PRIME](
        {commit}: AugmentedActionContext,
        date: string
    ): Promise<boolean>;

    [ActionTypes.FETCH_REPOS](
        {commit}: AugmentedActionContext,
        date: string
    ): Promise<Repo[]>;

    [ActionTypes.FETCH_PRODUCTS_REPO](
        {commit}: AugmentedActionContext,
        date: string
    ): Promise<Product[]>;

    [ActionTypes.CREATE_REPOS](
        {commit}: AugmentedActionContext,
        payload: Repo[]
    ): Promise<Repo[]>;

    [ActionTypes.ADD_USER_DATA](
        {commit}: AugmentedActionContext,
        credentials: LoginPayload
    ): Promise<User[]>;

    [ActionTypes.REMOVE_USER_DATA](
        {commit}: AugmentedActionContext,
        payload: any
    ): Promise<any>;

    [ActionTypes.SET_CHART_DATA](
        {commit}: AugmentedActionContext,
        payload: string
    ): Promise<any>;

    [ActionTypes.SET_CHART_ENABLED](
        {commit}: AugmentedActionContext,
        payload: IndexChartTick
    ): Promise<any>;

    [ActionTypes.POST_DRIFT_ALL](
        {commit}: AugmentedActionContext,
        payload: Drift
    ): any;

    [ActionTypes.SEND_TICK_DATA](
        {commit}: AugmentedActionContext,
        payload: NotificationSetting
    ): Promise<void>;

    [ActionTypes.LOAD_TICK_DATA](
        {commit}: AugmentedActionContext,
        user: any
    ): Promise<void>;

    [ActionTypes.FETCH_USERS_WITH_STRATS](
        {commit}: AugmentedActionContext,
        sorted_users: any
    ): Promise<User[]>;
}

// Define actions
export const actions: ActionTree<State, State> & Actions = {
    async [ActionTypes.FETCH_USERS_WITH_STRATS]({commit}, sorted_users) {

        return fetch.get('get_users_with_strats/').then(
            response => {
                const sorted_users = response.data.sort((a: any, b: any) => a.last_name.localeCompare(b.last_name))
                commit(MutationTypes.SET_USERS, sorted_users);

                return sorted_users
            },
            error => {
                if (error.response.status === 401) {
                }
                return error;
            });
    },
    async [ActionTypes.FETCH_NOTIFICATIONS]({commit}) {
        // Perform your request logic here, similar to FETCH_INDICES
        const response = await fetch.get('notifications/');
        // Optionally commit a mutation based on the response
        return response.data;
    },
    async [ActionTypes.PASSWORD_TOKEN_REQUEST]({commit}, payload: PasswordRequestToken) {
        const response = await fetch.post('auth/password_reset/', payload)
        return response.data
    },
    async [ActionTypes.SEND_TICK_DATA]({commit}, payload) {
        // Perform your request logic here, similar to FETCH_INDICES
        const response = await fetch.post('notification_settings/', payload);
        // Optionally commit a mutation based on the response
        return response.data;
    },
    async [ActionTypes.LOAD_TICK_DATA]({commit}, user) {
        // Perform your request logic here, similar to FETCH_INDICES
        const response = await fetch.get('notification_settings/', user);
        // Optionally commit a mutation based on the response
        return response.data;
    },
    async [ActionTypes.CHANGE_PASSWORD]({commit}, payload: PasswordChangeRequest) {
        const response = await fetch.post('auth/password_reset/confirm/', payload)
        return response.data
    },
    async [ActionTypes.INDEX_DELETE]({commit}, payload: number) {
        const response = await fetch.delete(`indices/delete/${payload}`)
        commit(MutationTypes.INDEX_DELETED, response.data)
        return response.data
    },
    async [ActionTypes.ADD_USER_DATA]({commit}, credentials) {
        return AuthService.login(credentials).then(
            auth_tokens => {
                commit(MutationTypes.loginSuccess, auth_tokens);

                return Promise.resolve(auth_tokens);
            },
            error => {
                if (error.response.status === 401) {
                }
                return error;
            }
        );

    },
    async [ActionTypes.REMOVE_USER_DATA]({commit}, payload: any) {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('current_user');
        commit(MutationTypes.SET_USER_DATA, null)
        return null
    },
    async [ActionTypes.FETCH_CURRENT_USER]({commit}) {
        commit(MutationTypes.SET_HAS_LOADED_USER, true)
        const response = await fetch.get('auth/current_user/')
        commit(MutationTypes.SET_CURRENT_USER, response.data)
        return response.data
    },
    async [ActionTypes.FETCH_INDICES]({commit}, category: IndicesCategories) {
        const response = await fetch.get(`indices/?is_active=True&category=${category}`)

        if (category != undefined) {
            commit(MutationTypes.SET_INDICES, response.data)
        }
        return response.data
    },
    async [ActionTypes.FETCH_USER_INDICES]({commit}, userID: number) {
        const response = await fetch.get(`indices/?is_active=True&user=${userID}`)
        commit(MutationTypes.SET_INDICES, response.data)
        return response.data
    },
    async [ActionTypes.FETCH_INDEX]({commit}, id: number) {
        const response = await fetch.get(`indices/${id}/`)
        commit(MutationTypes.SET_INDEX, response.data)
        return response.data
    },

    async [ActionTypes.FETCH_COPY_INDEX]({commit}, id: number) {
        const response = await fetch.get(`indices/${id}/`)
        const copy = {
            strat_name: '',
            productline_index: response.data.productline_index.map((productline: ProductLine) => {
                delete productline['index']
                delete productline['id']
                return productline
            }),
            creator: 0,
            trader: 0,
            is_active: true,
            is_submitted: false
        }
        commit(MutationTypes.SET_INDEX, copy)
        return copy
    },
    async [ActionTypes.FETCH_REPOS]({commit}, date: string) {
        let response
        if (date) {
            response = await fetch.get(`repo-history/?date=${date}`)
        } else {
            response = await fetch.get('repo-history/',
            )
        }
        commit(MutationTypes.SET_REPOS, response.data)
        return response.data
    },
    async [ActionTypes.POST_DRIFT]({commit}, payload: Drift) {
        const response = await fetch.post('drift_update/', payload)
        commit(MutationTypes.SET_DRIFT, response.data)
        return response.data
    },
    [ActionTypes.SET_CHART_ENABLED]({commit}, payload: IndexChartTick) {
        const response = fetch.post(`chart_update/`, payload)
        //commit( MutationTypes.CHART_DATA , response.data )
        return response;
    },
    [ActionTypes.POST_DRIFT_ALL](_, payload: Drift) {
        const response = fetch.post('drift_update/', payload)
        //commit( MutationTypes.SET_DRIFT , response.data )
        return response
    },
    async [ActionTypes.FETCH_PRODUCTS]({commit}) {
        const response = await fetch.get('products/?is_current=True')
        commit(MutationTypes.SET_PRODUCTS, response.data)
        localStorage.setItem('products', JSON.stringify(response.data))
        return response.data
    },

    async [ActionTypes.FETCH_PRODUCTS_D]({commit}) {
        const response = await fetch.get('products_d/?is_current=True')
        commit(MutationTypes.SET_PRODUCTS, response.data)
        localStorage.setItem('products', JSON.stringify(response.data))
        return response.data
    },

    async [ActionTypes.FETCH_PRODUCTS_REPO]({commit}, date: string) {
        let response
        if (date) {
            response = await fetch.get(`products_repo/?date=${date}`)
        } else {
            response = await fetch.get('products_repo/',
            )
        }
        commit(MutationTypes.SET_PRODUCTS_REPO, response.data)
        localStorage.setItem('products_repo', JSON.stringify(response.data))
        return response.data
    },

    async [ActionTypes.FETCH_USERS]({commit}, sorted_users) {

        return fetch.get('users/').then(
            response => {
                const sorted_users = response.data.sort((a: any, b: any) => a.last_name.localeCompare(b.last_name))
                commit(MutationTypes.SET_USERS, sorted_users);

                return sorted_users
            },
            error => {
                if (error.response.status === 401) {
                }
                return error;
            });
    },
    async [ActionTypes.CREATE_INDEX](_, payload: Index) {
        const response = await fetch.post('indices/', payload)
        return response.data
    },
    async [ActionTypes.SUBMIT_CALC_WEIGHTS](_, payload: Index) {
        const response = await fetch.post('indices/calculate_weights/', payload)
        return response.data
    },
    async [ActionTypes.SUBMIT_HOUSE_WEIGHTS](_, payload: Index) {
        const response = await fetch.post('indices/house_weights/', payload)
        return response.data
    },
    async [ActionTypes.SUBMIT_GENERATE_NAME](_, payload: Index) {
        const response = await fetch.post('indices/generate_name/', payload)
        return response.data
    },

    async [ActionTypes.SUBMIT_YIELD_CALC](_, payload: Yield[]) {
        const response = await fetch.post('bonds/calculate_yields/', payload)
        return response.data
    },
    async [ActionTypes.FETCH_RISK_LIST](_) {
        const response = await fetch.get('bonds/risk_list/')
        return response.data
    },
    async [ActionTypes.UPDATE_INDEX]({commit, state}, index: Index) {
        const response = await fetch.put(`indices/${index.id}/`, index)
        commit(MutationTypes.SET_INDEX, response.data)
        return response.data
    },
    async [ActionTypes.SET_INDEX]({commit}, index: Index) {
        commit(MutationTypes.SET_INDEX, index)
        return index
    },
    async [ActionTypes.RESET_INDEX]({commit}) {
        commit(MutationTypes.SET_INDEX, undefined)
        return true
    },
    async [ActionTypes.PUSH_TO_PRIME]({commit}, date: string) {
        if (date) {
            const response = await fetch.post(`prime_post/?date=${date}`)
            commit(MutationTypes.SET_PUSH_TO_PRIME, response.data)
            return response.data
        } else {
            commit(MutationTypes.SET_PUSH_TO_PRIME, false)
            localStorage.setItem('push_to_prime', JSON.stringify(false))
        }
    },

    async [ActionTypes.CREATE_REPOS]({commit}, payload: Repo[]) {
        const response = await fetch.post('repo-update/', payload)
        commit(MutationTypes.SET_REPOS, response.data)
        return response.data
    },
    [ActionTypes.SET_CHART_DATA]({commit}, strat_name: string) {
        const response = fetch.get(`chart_data?strat_name=${strat_name}`)
        //commit( MutationTypes.CHART_DATA , response.data )
        return response;
    },
    [ActionTypes.SET_CHART_ENABLED]({commit}, payload: IndexChartTick) {
        const response = fetch.post(`chart_update/`, payload)
        response.then(response => {
            response = response
        })
        return response;
    },

    async [ActionTypes.FETCH_ORDERS]({commit}) {
        const response = await fetch.get(`order_data_drop/`)
        commit(MutationTypes.SET_ORDER, response.data)
        return response.data
    },
    async [ActionTypes.FETCH_CLIENT_ORDERS]({commit}) {
        const response = await fetch.get(`client_order/`)
        commit(MutationTypes.SET_CLIENT_ORDER, response.data)
        return response.data
    },
    async [ActionTypes.FETCH_ORDER_USERS]({commit}) {
        const response = await fetch.get(`order_data_drop_usr/`)
        commit(MutationTypes.SET_ORDER_USERS, response.data)
        return response.data
    },
}

export type Store<S = State> = Omit<VuexStore<S>,
    'commit' | 'getters' | 'dispatch'> & {
    commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
        key: K,
        payload: P,
        options?: CommitOptions,
    ): ReturnType<Mutations[K]>;
} & {
    getters: {
        [K in keyof Getters]: ReturnType<Getters[K]>
    };
} & {
    dispatch<K extends keyof Actions>(
        key: K,
        payload: Parameters<Actions[K]>[1],
        options?: DispatchOptions,
    ): ReturnType<Actions[K]>;
}

export default createStore({
    state,
    getters,
    mutations,
    actions,
})
